import { ComponentType } from 'react';

export { parseRoutePath } from './parseRoutePath';

export const EAGER_MAUD_ROUTES = import.meta.glob(
  '/src/pages/maud/eager/**/[a-z[]*.tsx',
  {
    eager: true,
  },
) as Record<string, { default: ComponentType }>;

export const LAZY_MAUD_ROUTES = import.meta.glob(
  '/src/pages/maud/lazy/**/[a-z[]*.tsx',
) as Record<string, () => Promise<{ default: ComponentType }>>;
